var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FDF7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 18H44.0625C45.125 18 46.0625 18.9375 46.0625 20C46.0625 21.125 45.125 22 44.0625 22H36.9375C36.625 23.625 35.5 25 34.0625 25.625V44H44.0625C45.125 44 46.0625 44.9375 46.0625 46C46.0625 47.125 45.125 48 44.0625 48H32.0625H20.0625C18.9375 48 18.0625 47.125 18.0625 46C18.0625 44.9375 18.9375 44 20.0625 44H30.0625V25.625C28.5625 24.9375 27.4375 23.625 27.125 22H20.0625C18.9375 22 18.0625 21.125 18.0625 20C18.0625 18.9375 18.9375 18 20.0625 18H28.0625C28.9375 16.8125 30.375 16 32.0625 16C33.6875 16 35.125 16.8125 36.0625 18ZM39.5 36H48.5625L44.0625 28.25L39.5 36ZM44.0625 42C40.125 42 36.8125 39.875 36.1875 37.125C36 36.4375 36.25 35.6875 36.5625 35.0625L42.5 24.875C42.8125 24.375 43.4375 24 44.0625 24C44.625 24 45.25 24.375 45.5625 24.875L51.5 35.0625C51.875 35.6875 52.0625 36.4375 51.9375 37.125C51.25 39.875 47.9375 42 44.0625 42ZM19.9375 28.25L15.4375 36H24.5L19.9375 28.25ZM12.0625 37.125C11.9375 36.4375 12.125 35.6875 12.5 35.0625L18.4375 24.875C18.75 24.375 19.375 24 19.9375 24C20.5625 24 21.1875 24.375 21.5 24.875L27.4375 35.0625C27.75 35.6875 28 36.4375 27.8125 37.125C27.1875 39.875 23.875 42 19.9375 42C16 42 12.75 39.875 12.0625 37.125Z",
    fill: "#ECB31F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.4315b3e82d6e2f19db1b6e429493172f.svg";
export { ForwardRef as ReactComponent };